var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.906 9.7598H13.8264C14.2847 9.7598 14.656 10.1296 14.656 10.5931C14.656 11.0533 14.2854 11.4264 13.8264 11.4264H10.906V14.3467C10.906 14.805 10.5362 15.1764 10.0728 15.1764C9.6125 15.1764 9.23947 14.8057 9.23947 14.3467V11.4264H6.31911C5.86083 11.4264 5.48947 11.0566 5.48947 10.5931C5.48947 10.1328 5.86015 9.7598 6.31911 9.7598H9.23947V6.83945C9.23947 6.38116 9.60929 6.0098 10.0728 6.0098C10.533 6.0098 10.906 6.38048 10.906 6.83945V9.7598ZM10.0728 20.593C4.5499 20.593 0.0727539 16.1159 0.0727539 10.593C0.0727539 5.07016 4.5499 0.593018 10.0728 0.593018C15.5956 0.593018 20.0728 5.07016 20.0728 10.593C20.0728 16.1159 15.5956 20.593 10.0728 20.593ZM10.0728 18.9263C14.6753 18.9263 18.406 15.1956 18.406 10.5931C18.406 5.99059 14.6753 2.25987 10.0728 2.25987C5.47025 2.25987 1.73954 5.99059 1.73954 10.5931C1.73954 15.1956 5.47025 18.9263 10.0728 18.9263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBtn);
export default __webpack_public_path__ + "static/media/add_btn.7351d5ccaa941770e2764bcd9f8dc2de.svg";
export { ForwardRef as ReactComponent };